<script setup lang="ts">
  import { useLegacyAssets } from '@/composables/use-legacy-assets'
  import LegacyLayout from '@/views/legacy/LegacyLayout.vue'

  const { ready } = useLegacyAssets()
</script>

<template><LegacyLayout v-if="ready" /></template>
